import { render, staticRenderFns } from "./StudySelector.vue?vue&type=template&id=1f851daa&scoped=true&"
import script from "./StudySelector.vue?vue&type=script&lang=js&"
export * from "./StudySelector.vue?vue&type=script&lang=js&"
import style0 from "./StudySelector.vue?vue&type=style&index=0&id=1f851daa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f851daa",
  null
  
)

export default component.exports